// Whitepaper translations — ES / EN / SK
// Used exclusively by /whitepaper and /token/whitepaper. Self-contained.
export const WHITEPAPER_I18N = {
  es: {
    // Hero
    wp_back: "← RE₿EL",
    wp_subtitle: "El motor económico del ecosistema RE₿EL",
    wp_desc:
      "Impulsando educación, inteligencia artificial, trading social y comercio digital a través de una economía de token unificada.",
    wp_buy: "Comprar R₿L",
    wp_join: "Únete a la comunidad",
    wp_pdf: "Descargar PDF",

    // 01 Executive Summary
    s1_eyebrow: "// 01 RESUMEN EJECUTIVO",
    s1_title: "Una economía de token unificada",
    s1_para:
      "RE₿EL está construyendo un ecosistema completo que combina educación, inteligencia artificial, trading social y comercio digital — todo impulsado por el token R₿L.",
    s1_b1: "Educación",
    s1_b2: "Inteligencia Artificial",
    s1_b3: "Trading Social",
    s1_b4: "Comercio Digital",
    s1_p1: "Academy",
    s1_p2: "TrendIA",
    s1_p3: "Shadow Net",
    s1_p4: "TopWallet",
    s1_p5: "Market",
    s1_p6: "R₿L",

    // 02 Market
    s2_eyebrow: "// 02 OPORTUNIDAD DE MERCADO",
    s2_title: "Un panorama de billones",
    s2_m1: "IA",
    s2_m2: "Cripto",
    s2_m3: "Educación digital",
    s2_m4: "Economía de creadores",
    s2_sources:
      "Fuentes: estimaciones de la industria 2024-2026 (Statista, Messari, McKinsey, Block Research).",

    // 03 Ecosystem
    s3_eyebrow: "// 03 MAPA DEL ECOSISTEMA",
    s3_title: "Un token, seis pilares",
    s3_status_t: "Estado actual del ecosistema",
    s3_st1: "Shadow Network — perfiles, follow, mensajes AES-256, badges, feed, discovery y ranking semanal · activo",
    s3_st2: "Market Simulator™ — práctica de trading sin riesgo · activo",
    s3_st3: "TrendIA — en closed testing en Google Play",
    s3_st4: "RE₿EL Proof™ — 6 niveles de diploma ERC-1155 activos en Base L2",
    s3_st5: "Shadow Market — tienda activa",
    s3_st6: "Programa de referidos — activo",
    s3_n1: "RE₿EL Academy",
    s3_n2: "TrendIA",
    s3_n3: "Shadow Network",
    s3_n4: "TopWallet",
    s3_n5: "Shadow Market",
    s3_n6: "Token R₿L",
    s3_n7: "Base L2",

    // 04 Academy
    s4_eyebrow: "// 04 RE₿EL ACADEMY",
    s4_title: "Educación que recompensa",
    s4_c1_t: "Educación adultos",
    s4_c1_s: "Trading, macro, dominio DeFi",
    s4_c2_t: "Educación infantil",
    s4_c2_s: "Cultura financiera desde el día 1",
    s4_c3_t: "Certificados NFT",
    s4_c3_s: "RE₿EL Proof™ · ERC-1155 en Base L2",
    s4_c4_t: "Cursos de trading",
    s4_c4_s: "Spot, futuros, opciones",
    s4_c5_t: "Gamificación",
    s4_c5_s: "XP, niveles, misiones semanales",
    s4_c6_t: "Logros verificados",
    s4_c6_s: "Certificaciones reales",
    s4_c7_t: "Market Simulator™",
    s4_c7_s: "Práctica de trading sin riesgo con leaderboard",

    // 05 TrendIA
    s5_eyebrow: "// 05 TRENDIA",
    s5_title: "Mercados, decodificados por IA",
    s5_c1: "AI Brain",
    s5_c2: "Mapa de liquidez",
    s5_c3: "Smart Money",
    s5_c4: "Escáner de noticias",
    s5_c5: "Análisis de mercado",
    s5_c6: "Alertas",

    // 06 Shadow Network
    s6_eyebrow: "// 06 SHADOW NETWORK",
    s6_title: "Monetiza tu conocimiento de trading",
    s6_c1_t: "Suscripciones",
    s6_c1_s: "€ o R₿L recurrentes",
    s6_c2_t: "Señales premium",
    s6_c2_s: "Setups de pago cerrados",
    s6_c3_t: "Co-análisis",
    s6_c3_s: "Reparto 50/50",
    s6_c4_t: "Rankings",
    s6_c4_s: "Ranking semanal con premios",
    s6_c5_t: "Recompensas",
    s6_c5_s: "Gana R₿L por actividad y aciertos",
    s6_c6_t: "Mensajes cifrados",
    s6_c6_s: "Privados · cifrado AES-256",
    s6_flow: "// FLUJO DE INGRESOS DEL CREADOR",
    s6_pays: "El seguidor paga € o R₿L",
    s6_prizes:
      "Ranking semanal — Top 3: $300 / $200 / $100 USDC · Puestos 4-5: 50% / 25% de descuento en Shadow Market.",
    s6_analyst: "Analista 90%",
    s6_platform: "Plataforma 10%",

    // 07 TopWallet
    s7_eyebrow: "// 07 TOPWALLET",
    s7_title: "Elige la wallet correcta, siempre",
    s7_c1_t: "+140 wallets",
    s7_c1_s: "Catálogo curado hot/cold/HW",
    s7_c2_t: "AI Wallet Advisor",
    s7_c2_s: "Recomendación personalizada",
    s7_c3_t: "Rating de wallets",
    s7_c3_s: "Puntuación experta y comunidad",
    s7_c4_t: "Puntuaciones de seguridad",
    s7_c4_s: "Auditoría y postura open-source",
    s7_th1: "Wallet",
    s7_th2: "Tipo",
    s7_th3: "Seguridad",
    s7_th4: "Rating",
    s7_t1: "Hardware",
    s7_t2: "Navegador",
    s7_t3: "Móvil",
    s7_affiliates: "Programas de afiliación oficiales activos: Ledger y Trezor.",

    // 08 Market
    s8_eyebrow: "// 08 SHADOW MARKET",
    s8_title: "Merch premium, diseñada con IA",
    s8_c1: "Ropa personalizada",
    s8_c2: "Diseño con IA",
    s8_c3: "Productos digitales",
    s8_c4: "Merch premium",

    // 09 Tokenomics
    s9_eyebrow: "// 09 TOKENOMICS",
    s9_title: "1.000.000.000 R₿L",
    s9_supply: "SUPPLY R₿L",
    s9_d1: "Ecosistema",
    s9_d2: "Liquidez",
    s9_d3: "Recompensas",
    s9_d4: "Desarrollo",
    s9_d5: "Marketing",
    // Datos técnicos · liquidez bloqueada
    liq_lock_title: "Liquidez bloqueada",
    liq_lock_detail: "PancakeSwap Base · 1,168 Cake-LP · 12 meses",
    liq_lock_until: "Bloqueada hasta el 9 de junio de 2027",
    liq_lock_verify: "Verificación on-chain",
    liq_lock_cta: "Ver prueba en PinkLock",
    sec_lock_trust: "✅ Liquidez bloqueada 12 meses en PinkLock — verificable públicamente",
    tok_facts_title: "Datos verificables on-chain",
    tok_contract_t: "Token R₿L · ERC-20",
    tok_proof_t: "RE₿EL Proof™ · ERC-1155",
    tok_supply_note:
      "Supply fijo de 1.000.000.000 R₿L — el contrato no incluye funciones de minting ni burning.",
    s9_split_t: "Distribución de cada pago PRO en R₿L",
    s9_split_1: "Treasury — operaciones de la academia",
    s9_split_2: "Vault pool — yield para holders",
    s9_split_3: "Burn address — quemado permanente",
    tok_listings_t: "Listings y exchanges",
    tok_li1: "Uniswap V3 (Base) — activo",
    tok_li2: "PancakeSwap V2 (Base) — activo · LP bloqueado hasta el 09-06-2027",
    tok_li3: "CoinGecko — solicitud enviada",
    tok_li4: "CoinMarketCap — solicitud enviada · ticket #1372525",
    tok_pools_t: "Pools activos",
    tok_pools_v: "Uniswap V3 (Base) · PancakeSwap (Base)",

    // 10 Utility
    s10_eyebrow: "// 10 UTILIDAD DEL TOKEN",
    s10_title: "Qué desbloquea R₿L",
    s10_c1: "Acceso PRO",
    s10_c2: "Gobernanza",
    s10_c3: "15% dto. Shadow Market",
    s10_c4: "Recompensas",
    s10_c5: "Boost de visibilidad",
    s10_c6: "Suscripciones a analistas",
    s10_c7: "Staking ×1.5 (30 días)",
    s10_c8: "Airdrop RE₿EL Proof™",
    s10_vault_t: "R₿L Vault",
    s10_vault_s:
      "Los holders pueden depositar R₿L en el Vault y recibir mensualmente una parte del 20% de los ingresos PRO on-chain de la academia. Yield respaldado por ingresos reales del negocio, no especulación. Retiro disponible en cualquier momento (fee del 5% antes de 30 días · depósito mínimo 100.000 R₿L).",
    s10_c1_s: "50% dto. pagando con R₿L · $19.95 vs $39.90",
    s10_c8_s: "Automático por nivel de diploma",
    s10_c9: "Burning mecánico",
    s10_c9_s: "5% quemado en cada pago PRO, compras Shadow Market y recompensas Learn-to-Earn / RE₿EL Kombat",
    s10_c10: "Swap nativo",
    s10_c10_s: "Uniswap V3 Base · en rebelbtc.com",

    // 11 Roadmap
    s11_eyebrow: "// 11 ROADMAP",
    s11_title: "Siete fases",
    s11_done: "Completada",
    s11_progress: "En progreso",
    s11_soon: "Próximamente",
    s11_f1_t: "Token & Ledger",
    s11_f1: ["ERC-20 en Base L2", "Ledger interno R₿L", "Recompensas por actividad"],
    s11_f2_t: "Shadow Network",
    s11_f2: ["Feed social y señales", "Mentor IA · Journal", "Suscripciones y pagos"],
    s11_f3_t: "On-chain & Web3",
    s11_f3: ["Conversión 1:1 on-chain", "Wallet Connect (Base)", "Dual ledger"],
    s11_f4_t: "Liquidez & listings",
    s11_f4: ["Pools Uniswap · PancakeSwap", "LP bloqueado 12 meses", "DexScreener · GeckoTerminal"],
    s11_f5_t: "Ecosistema completo",
    s11_f5: ["Governance con R₿L", "Airdrop RE₿EL Proof™", "R₿L acceso PRO y cursos", "Copy Simulator", "Integración TrendIA"],
    s11_f6_t: "Token Economy avanzada",
    s11_f6: ["R₿L Vault — 20% ingresos PRO", "Burning multi-fuente 5%", "Learn-to-Earn academia", "Swap nativo Uniswap V3", "Dashboard tokenomics live", "CoinGecko · CMC en revisión"],
    s11_f7_t: "Expansión del ecosistema",
    s11_f7: ["RE₿EL Wallet móvil", "RE₿EL Kombat play-to-earn", "Torneos de trading R₿L", "RE₿EL Mentors · clases live", "NFT badges · RE₿EL DAO", "Listing en CEX"],

    // 16 Learn-to-Earn
    l2e_eyebrow: "// 16 LEARN-TO-EARN",
    l2e_title: "Aprende y gana $R₿L",
    l2e_intro: "RE₿EL Academy recompensa a los usuarios PRO con tokens $R₿L reales por completar capítulos. Sistema con verificación anti-trampa de 6 capas para garantizar aprendizaje real.",
    l2e_rewards_t: "Recompensas por capítulo",
    l2e_r1: "Básico: 500 – 2.000 R₿L",
    l2e_r2: "Intermedio: 1.500 – 5.000 R₿L",
    l2e_r3: "Avanzado: 3.000 – 10.000 R₿L",
    l2e_r4: "Bonus módulo completo: +25.000 R₿L",
    l2e_r5: "Bonus curso + diploma: +100.000 R₿L",
    l2e_dist_t: "Distribución de cada recompensa",
    l2e_dist_1: "95% → Wallet del alumno (R₿L reales · Base L2)",
    l2e_dist_2: "5% → Burn address (quemado permanente)",
    l2e_anti_t: "Sistema anti-trampa · 6 capas",
    l2e_a1: "Timer servidor-side · tiempo mínimo de lectura",
    l2e_a2: "Detección de actividad real · pings cada 30s",
    l2e_a3: "Quiz obligatorio · mínimo 4 de 5 correctas",
    l2e_a4: "Cooldown entre capítulos · 15-60 min",
    l2e_a5: "Límite diario · máximo 20.000 R₿L / día",
    l2e_a6: "Progresión ordenada · no se saltan capítulos",

    // 17 RE₿EL Kombat
    kombat_eyebrow: "// 17 RE₿EL KOMBAT",
    kombat_title: "Juego play-to-earn",
    kombat_intro: "Juego de lucha 1vs1 estilo Mortal Kombat con temática crypto. The Rebel combate contra 9 villanos del mundo crypto en niveles de dificultad creciente.",
    kombat_chars_t: "Personajes",
    kombat_c1: "Niveles 1-3 · Crypto Bear · Scam Bot · Regulator SEC",
    kombat_c2: "Niveles 4-6 · Crypto Whale · FUD Spreader · Dark Miner",
    kombat_c3: "Niveles 7-9 · Rug Puller · Moon Chaser · The Satoshi",
    kombat_rew_t: "Recompensas por victoria",
    kombat_rew_v: "Nivel 1: 500 R₿L → Nivel 9: 50.000 R₿L",
    kombat_dist_t: "Distribución",
    kombat_d1: "95% → Wallet del jugador ganador",
    kombat_d2: "5% → Burn address (quemado permanente)",
    kombat_limits_t: "Límites diarios",
    kombat_l1: "Máximo 10.000 R₿L por wallet / día",
    kombat_l2: "Máximo 3 partidas con recompensa / día",
    kombat_l3: "Solo PRO con wallet conectada",

    // 18 Burn Mechanisms
    burn5_eyebrow: "// 18 MECANISMOS DE BURNING",
    burn5_title: "5 fuentes de quema permanente",
    burn5_intro: "El token $R₿L tiene cinco mecanismos que reducen continuamente el supply circulante. Todos los tokens enviados a la burn address son irrecuperables.",
    burn5_addr: "Burn address: 0x000000000000000000000000000000000000dEaD",
    burn5_s1_t: "1 · Pago PRO con R₿L",
    burn5_s1_d: "5% quemado · 75% Treasury · 20% Vault pool",
    burn5_s2_t: "2 · Compras Shadow Market",
    burn5_s2_d: "5% quemado · 95% Treasury",
    burn5_s3_t: "3 · Recompensas Learn-to-Earn",
    burn5_s3_d: "5% quemado · 95% al alumno",
    burn5_s4_t: "4 · Recompensas RE₿EL Kombat",
    burn5_s4_d: "5% quemado · 95% al ganador",
    burn5_s5_t: "5 · Hall of Flame · burn voluntario",
    burn5_s5_d: "100% quemado · leaderboard público",


    // 12 Team
    s12_eyebrow: "// 12 EQUIPO",
    s12_title: "Constructores",
    s12_founder: "Founder",
    s12_ceo: "CEO",
    s12_d1: "Fundador del ecosistema RE₿EL.",
    s12_d2: "Director ejecutivo.",

    // 13 Metrics
    s13_eyebrow: "// 13 MÉTRICAS DEL TOKEN",
    s13_title: "En cifras",
    s13_network: "Red",
    s13_supply: "Supply",
    s13_products: "Productos",
    s13_core: "Plataformas principales",

    // 14 Links
    s14_eyebrow: "// 14 ENLACES OFICIALES",
    s14_title: "Dónde encontrarnos",

    // 15 Legal
    s15_eyebrow: "// 15 LEGAL",
    s15_title: "Disclaimers",
    s15_risk_t: "Disclaimer de riesgo",
    s15_risk_b:
      "Los mercados de criptomonedas son altamente volátiles y especulativos. El precio de R₿L — y el de cualquier activo digital — puede fluctuar de forma significativa y rápida. Nunca inviertas más de lo que puedas permitirte perder. Nada en este documento constituye asesoría financiera, de inversión, legal o fiscal. Realiza siempre tu propia investigación (DYOR) y consulta a un profesional cualificado antes de tomar cualquier decisión.",
    s15_privacy_t: "Política de privacidad",
    s15_privacy_b:
      "RE₿EL recopila únicamente los datos estrictamente necesarios para operar sus servicios (cuenta, e-mail, interacciones on-chain, analítica anónima). No vendemos datos personales a terceros. Los usuarios pueden solicitar acceso, corrección o eliminación de sus datos en cualquier momento. Detalles completos en rebelbtc.com/privacy.",
    s15_tos_t: "Términos del servicio",
    s15_tos_b:
      "Al acceder al ecosistema RE₿EL (Academy, TrendIA, Shadow Network, TopWallet, Shadow Market) aceptas los Términos del Servicio de la plataforma. Los servicios se ofrecen 'tal cual', sin garantías de ningún tipo. RE₿EL no se responsabiliza de pérdidas en trading, contenido de terceros ni interrupciones del servicio. Términos completos en rebelbtc.com/terms.",
    s15_token_t: "Disclaimer del token",
    s15_token_b:
      "R₿L es un token de utilidad utilizado dentro del ecosistema RE₿EL para acceso, recompensas, gobernanza y comercio. R₿L NO es un valor, NO es un contrato de inversión, y NO representa una acción, equity, dividendo o derecho sobre la empresa. Poseer R₿L no otorga al titular ningún derecho económico fuera de la utilidad publicada del ecosistema. El tratamiento regulatorio de los activos digitales puede evolucionar; cada usuario es responsable del cumplimiento normativo en su jurisdicción.",
    s15_legal_note:
      "R₿L es un token de utilidad dentro del ecosistema RE₿EL. No es un valor ni está destinado como instrumento de inversión. Las criptomonedas conllevan riesgo. El rendimiento pasado no garantiza resultados futuros. Realiza siempre tu propia investigación.",

    // Footer
    foot_motto: "Libertad · Inteligencia · Descentralización",
  },

  en: {
    wp_back: "← RE₿EL",
    wp_subtitle: "The Economic Engine of the RE₿EL Ecosystem",
    wp_desc:
      "Powering education, artificial intelligence, social trading and digital commerce through a unified token economy.",
    wp_buy: "Buy R₿L",
    wp_join: "Join Community",
    wp_pdf: "Download PDF",

    s1_eyebrow: "// 01 EXECUTIVE SUMMARY",
    s1_title: "A unified token economy",
    s1_para:
      "RE₿EL is building a complete ecosystem combining education, artificial intelligence, social trading and digital commerce — all powered by the R₿L token.",
    s1_b1: "Education",
    s1_b2: "Artificial Intelligence",
    s1_b3: "Social Trading",
    s1_b4: "Digital Commerce",
    s1_p1: "Academy",
    s1_p2: "TrendIA",
    s1_p3: "Shadow Net",
    s1_p4: "TopWallet",
    s1_p5: "Market",
    s1_p6: "R₿L",

    s2_eyebrow: "// 02 MARKET OPPORTUNITY",
    s2_title: "A trillion-dollar landscape",
    s2_m1: "AI",
    s2_m2: "Crypto",
    s2_m3: "Digital Education",
    s2_m4: "Creator Economy",
    s2_sources:
      "Sources: industry estimates 2024-2026 (Statista, Messari, McKinsey, Block Research).",

    s3_eyebrow: "// 03 ECOSYSTEM MAP",
    s3_title: "One token, six pillars",
    s3_status_t: "Current ecosystem status",
    s3_st1: "Shadow Network — profiles, follow, AES-256 messages, badges, feed, discovery & weekly ranking · live",
    s3_st2: "Market Simulator™ — risk-free trading practice · live",
    s3_st3: "TrendIA — closed testing on Google Play",
    s3_st4: "RE₿EL Proof™ — 6 diploma tiers ERC-1155 live on Base L2",
    s3_st5: "Shadow Market — store live",
    s3_st6: "Referral program — live",
    s3_n1: "RE₿EL Academy",
    s3_n2: "TrendIA",
    s3_n3: "Shadow Network",
    s3_n4: "TopWallet",
    s3_n5: "Shadow Market",
    s3_n6: "R₿L Token",
    s3_n7: "Base L2",

    s4_eyebrow: "// 04 RE₿EL ACADEMY",
    s4_title: "Education that earns",
    s4_c1_t: "Adult Education",
    s4_c1_s: "Trading, macro, DeFi mastery",
    s4_c2_t: "Kids Education",
    s4_c2_s: "Financial literacy from day one",
    s4_c3_t: "NFT Certificates",
    s4_c3_s: "RE₿EL Proof™ · ERC-1155 on Base L2",
    s4_c4_t: "Trading Courses",
    s4_c4_s: "Spot, futures, options",
    s4_c5_t: "Gamification",
    s4_c5_s: "XP, levels, weekly missions",
    s4_c6_t: "Achievement System",
    s4_c6_s: "Verified accomplishments",
    s4_c7_t: "Market Simulator™",
    s4_c7_s: "Risk-free trading practice with leaderboard",

    s5_eyebrow: "// 05 TRENDIA",
    s5_title: "Markets, decoded by AI",
    s5_c1: "AI Brain",
    s5_c2: "Liquidity Map",
    s5_c3: "Smart Money",
    s5_c4: "News Scanner",
    s5_c5: "Market Analysis",
    s5_c6: "Alerts",

    s6_eyebrow: "// 06 SHADOW NETWORK",
    s6_title: "Monetize your trading knowledge",
    s6_c1_t: "Subscriptions",
    s6_c1_s: "€ or R₿L recurring",
    s6_c2_t: "Premium Signals",
    s6_c2_s: "Gated paid setups",
    s6_c3_t: "Co-Analysis",
    s6_c3_s: "50/50 revenue split",
    s6_c4_t: "Leaderboards",
    s6_c4_s: "Weekly ranking with prizes",
    s6_c5_t: "Rewards",
    s6_c5_s: "Earn R₿L for activity and accuracy",
    s6_c6_t: "Encrypted Messages",
    s6_c6_s: "Private · AES-256 encryption",
    s6_flow: "// CREATOR REVENUE FLOW",
    s6_pays: "Follower pays € or R₿L",
    s6_prizes:
      "Weekly ranking — Top 3: $300 / $200 / $100 USDC · Ranks 4-5: 50% / 25% Shadow Market discount.",
    s6_analyst: "Analyst 90%",
    s6_platform: "Platform 10%",

    s7_eyebrow: "// 07 TOPWALLET",
    s7_title: "Pick the right wallet, always",
    s7_c1_t: "140+ Wallets",
    s7_c1_s: "Curated catalog hot/cold/HW",
    s7_c2_t: "AI Wallet Advisor",
    s7_c2_s: "Personalized recommendation",
    s7_c3_t: "Wallet Ratings",
    s7_c3_s: "Community + expert scoring",
    s7_c4_t: "Security Scores",
    s7_c4_s: "Audit + open-source posture",
    s7_th1: "Wallet",
    s7_th2: "Type",
    s7_th3: "Security",
    s7_th4: "Rating",
    s7_t1: "Hardware",
    s7_t2: "Browser",
    s7_t3: "Mobile",
    s7_affiliates: "Active official affiliate programs: Ledger and Trezor.",

    s8_eyebrow: "// 08 SHADOW MARKET",
    s8_title: "Premium merch, AI-designed",
    s8_c1: "Custom Clothing",
    s8_c2: "AI Design",
    s8_c3: "Digital Products",
    s8_c4: "Premium Merch",

    s9_eyebrow: "// 09 TOKENOMICS",
    s9_title: "1,000,000,000 R₿L",
    s9_supply: "R₿L SUPPLY",
    s9_d1: "Ecosystem",
    s9_d2: "Liquidity",
    s9_d3: "Rewards",
    s9_d4: "Development",
    s9_d5: "Marketing",
    // Tech facts · locked liquidity
    liq_lock_title: "Locked liquidity",
    liq_lock_detail: "PancakeSwap Base · 1,168 Cake-LP · 12 months",
    liq_lock_until: "Locked until June 9, 2027",
    liq_lock_verify: "On-chain verification",
    liq_lock_cta: "View PinkLock proof",
    sec_lock_trust: "✅ 12-month locked liquidity on PinkLock — publicly verifiable",
    tok_facts_title: "Verifiable on-chain data",
    tok_contract_t: "R₿L Token · ERC-20",
    tok_proof_t: "RE₿EL Proof™ · ERC-1155",
    tok_supply_note:
      "Fixed supply of 1,000,000,000 R₿L — the contract includes no minting or burning functions.",
    s9_split_t: "Distribution of every PRO payment in R₿L",
    s9_split_1: "Treasury — academy operations",
    s9_split_2: "Vault pool — yield for holders",
    s9_split_3: "Burn address — permanently burned",
    tok_listings_t: "Listings & exchanges",
    tok_li1: "Uniswap V3 (Base) — live",
    tok_li2: "PancakeSwap V2 (Base) — live · LP locked until 2027-06-09",
    tok_li3: "CoinGecko — application submitted",
    tok_li4: "CoinMarketCap — application submitted · ticket #1372525",
    tok_pools_t: "Active pools",
    tok_pools_v: "Uniswap V3 (Base) · PancakeSwap (Base)",

    s10_eyebrow: "// 10 TOKEN UTILITY",
    s10_title: "What R₿L unlocks",
    s10_c1: "PRO Access",
    s10_c2: "Governance",
    s10_c3: "15% Shadow Market discount",
    s10_c4: "Rewards",
    s10_c5: "Visibility Boost",
    s10_c6: "Analyst Subscriptions",
    s10_c7: "Staking ×1.5 (30 days)",
    s10_c8: "RE₿EL Proof™ Airdrop",
    s10_vault_t: "R₿L Vault",
    s10_vault_s:
      "Holders can deposit R₿L in the Vault and receive a monthly share of 20% of the academy's on-chain PRO revenue. Yield backed by real business income, not speculation. Withdraw anytime (5% fee before 30 days · minimum deposit 100,000 R₿L).",
    s10_c1_s: "50% off paying with R₿L · $19.95 vs $39.90",
    s10_c8_s: "Automatic by diploma tier",
    s10_c9: "Mechanical Burning",
    s10_c9_s: "5% burned on every PRO payment, Shadow Market purchase and Learn-to-Earn / RE₿EL Kombat reward",
    s10_c10: "Native Swap",
    s10_c10_s: "Uniswap V3 Base · on rebelbtc.com",

    s11_eyebrow: "// 11 ROADMAP",
    s11_title: "Seven phases",
    s11_done: "Completed",
    s11_progress: "In progress",
    s11_soon: "Coming soon",
    s11_f1_t: "Token & Ledger",
    s11_f1: ["ERC-20 on Base L2", "Internal R₿L ledger", "Activity rewards"],
    s11_f2_t: "Shadow Network",
    s11_f2: ["Social feed & signals", "AI Mentor · Journal", "Subscriptions & payments"],
    s11_f3_t: "On-chain & Web3",
    s11_f3: ["1:1 on-chain conversion", "Wallet Connect (Base)", "Dual ledger"],
    s11_f4_t: "Liquidity & listings",
    s11_f4: ["Uniswap · PancakeSwap pools", "LP locked 12 months", "DexScreener · GeckoTerminal"],
    s11_f5_t: "Full ecosystem",
    s11_f5: ["Governance with R₿L", "RE₿EL Proof™ airdrop", "R₿L PRO & course access", "Copy Simulator", "TrendIA integration"],
    s11_f6_t: "Advanced Token Economy",
    s11_f6: ["R₿L Vault — 20% PRO revenue", "Multi-source burning 5%", "Learn-to-Earn academy", "Native swap Uniswap V3", "Live tokenomics dashboard", "CoinGecko · CMC under review"],
    s11_f7_t: "Ecosystem expansion",
    s11_f7: ["RE₿EL Wallet mobile", "RE₿EL Kombat play-to-earn", "R₿L trading tournaments", "RE₿EL Mentors · live classes", "NFT badges · RE₿EL DAO", "CEX listing"],

    // 16 Learn-to-Earn
    l2e_eyebrow: "// 16 LEARN-TO-EARN",
    l2e_title: "Learn and earn $R₿L",
    l2e_intro: "RE₿EL Academy rewards PRO users with real $R₿L tokens for completing chapters. 6-layer anti-cheat verification system ensures real learning.",
    l2e_rewards_t: "Rewards per chapter",
    l2e_r1: "Basic: 500 – 2,000 R₿L",
    l2e_r2: "Intermediate: 1,500 – 5,000 R₿L",
    l2e_r3: "Advanced: 3,000 – 10,000 R₿L",
    l2e_r4: "Module complete bonus: +25,000 R₿L",
    l2e_r5: "Course + diploma bonus: +100,000 R₿L",
    l2e_dist_t: "Reward distribution",
    l2e_dist_1: "95% → Student wallet (real R₿L · Base L2)",
    l2e_dist_2: "5% → Burn address (permanent burn)",
    l2e_anti_t: "Anti-cheat system · 6 layers",
    l2e_a1: "Server-side timer · minimum reading time",
    l2e_a2: "Real activity detection · pings every 30s",
    l2e_a3: "Mandatory quiz · minimum 4 of 5 correct",
    l2e_a4: "Cooldown between chapters · 15-60 min",
    l2e_a5: "Daily limit · max 20,000 R₿L / day",
    l2e_a6: "Ordered progression · no skipping chapters",

    // 17 RE₿EL Kombat
    kombat_eyebrow: "// 17 RE₿EL KOMBAT",
    kombat_title: "Play-to-earn game",
    kombat_intro: "1vs1 fighting game Mortal Kombat-style with crypto theme. The Rebel fights 9 villains from the crypto world across increasing difficulty levels.",
    kombat_chars_t: "Characters",
    kombat_c1: "Levels 1-3 · Crypto Bear · Scam Bot · Regulator SEC",
    kombat_c2: "Levels 4-6 · Crypto Whale · FUD Spreader · Dark Miner",
    kombat_c3: "Levels 7-9 · Rug Puller · Moon Chaser · The Satoshi",
    kombat_rew_t: "Rewards per win",
    kombat_rew_v: "Level 1: 500 R₿L → Level 9: 50,000 R₿L",
    kombat_dist_t: "Distribution",
    kombat_d1: "95% → Winner wallet",
    kombat_d2: "5% → Burn address (permanent burn)",
    kombat_limits_t: "Daily limits",
    kombat_l1: "Max 10,000 R₿L per wallet / day",
    kombat_l2: "Max 3 reward matches / day",
    kombat_l3: "PRO only with connected wallet",

    // 18 Burn Mechanisms
    burn5_eyebrow: "// 18 BURNING MECHANISMS",
    burn5_title: "5 sources of permanent burn",
    burn5_intro: "The $R₿L token has five mechanisms continuously reducing circulating supply. All tokens sent to the burn address are irrecoverable.",
    burn5_addr: "Burn address: 0x000000000000000000000000000000000000dEaD",
    burn5_s1_t: "1 · PRO payment with R₿L",
    burn5_s1_d: "5% burned · 75% Treasury · 20% Vault pool",
    burn5_s2_t: "2 · Shadow Market purchases",
    burn5_s2_d: "5% burned · 95% Treasury",
    burn5_s3_t: "3 · Learn-to-Earn rewards",
    burn5_s3_d: "5% burned · 95% to student",
    burn5_s4_t: "4 · RE₿EL Kombat rewards",
    burn5_s4_d: "5% burned · 95% to winner",
    burn5_s5_t: "5 · Hall of Flame · voluntary burn",
    burn5_s5_d: "100% burned · public leaderboard",


    s12_eyebrow: "// 12 TEAM",
    s12_title: "Builders",
    s12_founder: "Founder",
    s12_ceo: "CEO",
    s12_d1: "Founder of the RE₿EL ecosystem.",
    s12_d2: "Chief Executive Officer.",

    s13_eyebrow: "// 13 TOKEN METRICS",
    s13_title: "By the numbers",
    s13_network: "Network",
    s13_supply: "Supply",
    s13_products: "Products",
    s13_core: "Core Platforms",

    s14_eyebrow: "// 14 OFFICIAL LINKS",
    s14_title: "Where to find us",

    s15_eyebrow: "// 15 LEGAL",
    s15_title: "Disclaimers",
    s15_risk_t: "Risk Disclaimer",
    s15_risk_b:
      "Cryptocurrency markets are highly volatile and speculative. The price of R₿L — and of any digital asset — may fluctuate significantly and rapidly. You should never invest more than you can afford to lose. Nothing in this document constitutes financial, investment, legal, or tax advice. Always conduct your own research (DYOR) and consult a qualified professional before making any decision.",
    s15_privacy_t: "Privacy Policy",
    s15_privacy_b:
      "RE₿EL collects only the data strictly necessary to operate its services (account, e-mail, on-chain interactions, anonymous analytics). We do not sell personal data to third parties. Users may request access, correction, or deletion of their data at any time. Full details are available at rebelbtc.com/privacy.",
    s15_tos_t: "Terms of Service",
    s15_tos_b:
      "By accessing the RE₿EL ecosystem (Academy, TrendIA, Shadow Network, TopWallet, Shadow Market) you agree to the platform's Terms of Service. The services are provided 'as is', without warranties of any kind. RE₿EL is not liable for trading losses, third-party content, or interruptions of service. Full terms at rebelbtc.com/terms.",
    s15_token_t: "Token Disclaimer",
    s15_token_b:
      "R₿L is a utility token used within the RE₿EL ecosystem for access, rewards, governance, and commerce. R₿L is NOT a security, NOT an investment contract, and does NOT represent a share, equity, dividend, or claim on the company. Holding R₿L does not entitle the holder to any economic right outside of the ecosystem's published utility. Regulatory treatment of digital assets may evolve; users are responsible for compliance in their own jurisdiction.",
    s15_legal_note:
      "R₿L is a utility token within the RE₿EL ecosystem. It is not a security and is not intended as an investment instrument. Cryptocurrency carries risk. Past performance does not guarantee future results. Always do your own research.",

    foot_motto: "Freedom · Intelligence · Decentralization",
  },

  sk: {
    wp_back: "← RE₿EL",
    wp_subtitle: "Ekonomický motor ekosystému RE₿EL",
    wp_desc:
      "Poháňame vzdelávanie, umelú inteligenciu, sociálne obchodovanie a digitálny obchod prostredníctvom jednotnej tokenovej ekonomiky.",
    wp_buy: "Kúpiť R₿L",
    wp_join: "Pridať sa ku komunite",
    wp_pdf: "Stiahnuť PDF",

    s1_eyebrow: "// 01 ZHRNUTIE",
    s1_title: "Jednotná tokenová ekonomika",
    s1_para:
      "RE₿EL buduje kompletný ekosystém spájajúci vzdelávanie, umelú inteligenciu, sociálne obchodovanie a digitálny obchod — všetko poháňané tokenom R₿L.",
    s1_b1: "Vzdelávanie",
    s1_b2: "Umelá inteligencia",
    s1_b3: "Sociálne obchodovanie",
    s1_b4: "Digitálny obchod",
    s1_p1: "Academy",
    s1_p2: "TrendIA",
    s1_p3: "Shadow Net",
    s1_p4: "TopWallet",
    s1_p5: "Market",
    s1_p6: "R₿L",

    s2_eyebrow: "// 02 PRÍLEŽITOSŤ NA TRHU",
    s2_title: "Trh za bilióny dolárov",
    s2_m1: "AI",
    s2_m2: "Kryptomeny",
    s2_m3: "Digitálne vzdelávanie",
    s2_m4: "Ekonomika tvorcov",
    s2_sources:
      "Zdroje: odhady odvetvia 2024-2026 (Statista, Messari, McKinsey, Block Research).",

    s3_eyebrow: "// 03 MAPA EKOSYSTÉMU",
    s3_title: "Jeden token, šesť pilierov",
    s3_status_t: "Aktuálny stav ekosystému",
    s3_st1: "Shadow Network — profily, follow, AES-256 správy, odznaky, feed, discovery a týždenný rebríček · aktívne",
    s3_st2: "Market Simulator™ — bezrizikový tréning tradingu · aktívny",
    s3_st3: "TrendIA — closed testing na Google Play",
    s3_st4: "RE₿EL Proof™ — 6 úrovní diplomov ERC-1155 aktívnych na Base L2",
    s3_st5: "Shadow Market — obchod aktívny",
    s3_st6: "Referral program — aktívny",
    s3_n1: "RE₿EL Academy",
    s3_n2: "TrendIA",
    s3_n3: "Shadow Network",
    s3_n4: "TopWallet",
    s3_n5: "Shadow Market",
    s3_n6: "Token R₿L",
    s3_n7: "Base L2",

    s4_eyebrow: "// 04 RE₿EL ACADEMY",
    s4_title: "Vzdelávanie, ktoré odmeňuje",
    s4_c1_t: "Vzdelávanie dospelých",
    s4_c1_s: "Trading, makro, DeFi majstrovstvo",
    s4_c2_t: "Vzdelávanie detí",
    s4_c2_s: "Finančná gramotnosť od prvého dňa",
    s4_c3_t: "NFT certifikáty",
    s4_c3_s: "RE₿EL Proof™ · ERC-1155 na Base L2",
    s4_c4_t: "Kurzy tradingu",
    s4_c4_s: "Spot, futures, opcie",
    s4_c5_t: "Gamifikácia",
    s4_c5_s: "XP, levely, týždenné misie",
    s4_c6_t: "Systém ocenení",
    s4_c6_s: "Overené úspechy",
    s4_c7_t: "Market Simulator™",
    s4_c7_s: "Bezrizikový tréning tradingu s rebríčkom",

    s5_eyebrow: "// 05 TRENDIA",
    s5_title: "Trhy dekódované AI",
    s5_c1: "AI Brain",
    s5_c2: "Mapa likvidity",
    s5_c3: "Smart Money",
    s5_c4: "Skener správ",
    s5_c5: "Analýza trhu",
    s5_c6: "Upozornenia",

    s6_eyebrow: "// 06 SHADOW NETWORK",
    s6_title: "Speňaž svoje obchodné znalosti",
    s6_c1_t: "Predplatné",
    s6_c1_s: "€ alebo R₿L pravidelne",
    s6_c2_t: "Prémiové signály",
    s6_c2_s: "Platené uzamknuté setupy",
    s6_c3_t: "Spoločná analýza",
    s6_c3_s: "Rozdelenie príjmov 50/50",
    s6_c4_t: "Rebríčky",
    s6_c4_s: "Týždenný rebríček s cenami",
    s6_c5_t: "Odmeny",
    s6_c5_s: "Získaj R₿L za aktivitu a presnosť",
    s6_c6_t: "Šifrované správy",
    s6_c6_s: "Súkromné · šifrovanie AES-256",
    s6_flow: "// TOK PRÍJMOV TVORCU",
    s6_pays: "Sledovateľ platí € alebo R₿L",
    s6_prizes:
      "Týždenný rebríček — Top 3: $300 / $200 / $100 USDC · Pozície 4-5: 50% / 25% zľava v Shadow Market.",
    s6_analyst: "Analytik 90%",
    s6_platform: "Platforma 10%",

    s7_eyebrow: "// 07 TOPWALLET",
    s7_title: "Vždy vyber správnu peňaženku",
    s7_c1_t: "140+ peňaženiek",
    s7_c1_s: "Kurátorský katalóg hot/cold/HW",
    s7_c2_t: "AI Wallet Advisor",
    s7_c2_s: "Personalizované odporúčanie",
    s7_c3_t: "Hodnotenia peňaženiek",
    s7_c3_s: "Komunita + expertné skóre",
    s7_c4_t: "Skóre zabezpečenia",
    s7_c4_s: "Audit + open-source prístup",
    s7_th1: "Peňaženka",
    s7_th2: "Typ",
    s7_th3: "Zabezpečenie",
    s7_th4: "Hodnotenie",
    s7_t1: "Hardvér",
    s7_t2: "Prehliadač",
    s7_t3: "Mobil",
    s7_affiliates: "Aktívne oficiálne affiliate programy: Ledger a Trezor.",

    s8_eyebrow: "// 08 SHADOW MARKET",
    s8_title: "Prémiový merch, dizajn s AI",
    s8_c1: "Vlastné oblečenie",
    s8_c2: "AI dizajn",
    s8_c3: "Digitálne produkty",
    s8_c4: "Prémiový merch",

    s9_eyebrow: "// 09 TOKENOMICS",
    s9_title: "1 000 000 000 R₿L",
    s9_supply: "R₿L SUPPLY",
    s9_d1: "Ekosystém",
    s9_d2: "Likvidita",
    s9_d3: "Odmeny",
    s9_d4: "Vývoj",
    s9_d5: "Marketing",
    // Technické údaje · uzamknutá likvidita
    liq_lock_title: "Uzamknutá likvidita",
    liq_lock_detail: "PancakeSwap Base · 1 168 Cake-LP · 12 mesiacov",
    liq_lock_until: "Uzamknuté do 9. júna 2027",
    liq_lock_verify: "On-chain overenie",
    liq_lock_cta: "Zobraziť dôkaz na PinkLock",
    sec_lock_trust: "✅ Likvidita uzamknutá na 12 mesiacov na PinkLock — verejne overiteľné",
    tok_facts_title: "Overiteľné on-chain údaje",
    tok_contract_t: "Token R₿L · ERC-20",
    tok_proof_t: "RE₿EL Proof™ · ERC-1155",
    tok_supply_note:
      "Fixný supply 1 000 000 000 R₿L — kontrakt neobsahuje funkcie mintingu ani burningu.",
    s9_split_t: "Distribúcia každej PRO platby v R₿L",
    s9_split_1: "Treasury — prevádzka akadémie",
    s9_split_2: "Vault pool — výnos pre holderov",
    s9_split_3: "Burn adresa — trvalo spálené",
    tok_listings_t: "Listingy a burzy",
    tok_li1: "Uniswap V3 (Base) — aktívny",
    tok_li2: "PancakeSwap V2 (Base) — aktívny · LP uzamknuté do 09.06.2027",
    tok_li3: "CoinGecko — žiadosť odoslaná",
    tok_li4: "CoinMarketCap — žiadosť odoslaná · ticket #1372525",
    tok_pools_t: "Aktívne pooly",
    tok_pools_v: "Uniswap V3 (Base) · PancakeSwap (Base)",

    s10_eyebrow: "// 10 VYUŽITIE TOKENU",
    s10_title: "Čo odomyká R₿L",
    s10_c1: "PRO prístup",
    s10_c2: "Governance",
    s10_c3: "15% zľava Shadow Market",
    s10_c4: "Odmeny",
    s10_c5: "Boost viditeľnosti",
    s10_c6: "Predplatné analytikov",
    s10_c7: "Staking ×1.5 (30 dní)",
    s10_c8: "Airdrop RE₿EL Proof™",
    s10_vault_t: "R₿L Vault",
    s10_vault_s:
      "Držitelia môžu vložiť R₿L do Vaultu a mesačne dostávať podiel z 20 % on-chain PRO príjmov akadémie. Výnos krytý reálnymi príjmami, nie špekuláciou. Výber kedykoľvek (poplatok 5 % pred 30 dňami · minimálny vklad 100 000 R₿L).",

    s11_eyebrow: "// 11 ROADMAP",
    s11_title: "Sedem fáz",
    s11_done: "Dokončená",
    s11_progress: "Prebieha",
    s11_soon: "Čoskoro",
    s11_f1_t: "Token & Ledger",
    s11_f1: ["ERC-20 na Base L2", "Interný R₿L ledger", "Odmeny za aktivitu"],
    s11_f2_t: "Shadow Network",
    s11_f2: ["Sociálny feed a signály", "AI Mentor · Journal", "Predplatné a platby"],
    s11_f3_t: "On-chain & Web3",
    s11_f3: ["Konverzia 1:1 on-chain", "Wallet Connect (Base)", "Duálny ledger"],
    s11_f4_t: "Likvidita & listingy",
    s11_f4: ["Pooly Uniswap · PancakeSwap", "LP uzamknuté 12 mesiacov", "DexScreener · GeckoTerminal"],
    s11_f5_t: "Kompletný ekosystém",
    s11_f5: ["Governance s R₿L", "Airdrop RE₿EL Proof™", "R₿L prístup k PRO a kurzom", "Copy Simulator", "Integrácia TrendIA"],
    s11_f6_t: "Pokročilá Token Economy",
    s11_f6: ["R₿L Vault — 20 % PRO príjmov", "Multi-zdrojový burning 5 %", "Learn-to-Earn akadémia", "Natívny swap Uniswap V3", "Live tokenomics dashboard", "CoinGecko · CMC v posudzovaní"],
    s11_f7_t: "Expanzia ekosystému",
    s11_f7: ["RE₿EL Wallet mobilná appka", "RE₿EL Kombat play-to-earn", "R₿L trading turnaje", "RE₿EL Mentors · live lekcie", "NFT odznaky · RE₿EL DAO", "Listing na CEX"],

    // 16 Learn-to-Earn
    l2e_eyebrow: "// 16 LEARN-TO-EARN",
    l2e_title: "Učte sa a zarábajte $R₿L",
    l2e_intro: "RE₿EL Academy odmeňuje PRO používateľov reálnymi $R₿L tokenmi za dokončenie kapitol. 6-vrstvový anti-podvodný systém zaručuje skutočné učenie.",
    l2e_rewards_t: "Odmeny za kapitolu",
    l2e_r1: "Základná: 500 – 2 000 R₿L",
    l2e_r2: "Stredná: 1 500 – 5 000 R₿L",
    l2e_r3: "Pokročilá: 3 000 – 10 000 R₿L",
    l2e_r4: "Bonus za celý modul: +25 000 R₿L",
    l2e_r5: "Bonus za kurz + diplom: +100 000 R₿L",
    l2e_dist_t: "Distribúcia odmeny",
    l2e_dist_1: "95 % → Peňaženka študenta (reálne R₿L · Base L2)",
    l2e_dist_2: "5 % → Burn adresa (trvalé spálenie)",
    l2e_anti_t: "Anti-podvodný systém · 6 vrstiev",
    l2e_a1: "Serverový timer · minimálny čas čítania",
    l2e_a2: "Detekcia reálnej aktivity · pingy každých 30s",
    l2e_a3: "Povinný kvíz · minimum 4 z 5 správnych",
    l2e_a4: "Cooldown medzi kapitolami · 15-60 min",
    l2e_a5: "Denný limit · max 20 000 R₿L / deň",
    l2e_a6: "Postupné poradie · kapitoly sa nedajú preskočiť",

    // 17 RE₿EL Kombat
    kombat_eyebrow: "// 17 RE₿EL KOMBAT",
    kombat_title: "Play-to-earn hra",
    kombat_intro: "Bojová hra 1vs1 v štýle Mortal Kombat s krypto tematikou. The Rebel bojuje proti 9 záporákom z krypto sveta na rastúcich úrovniach obtiažnosti.",
    kombat_chars_t: "Postavy",
    kombat_c1: "Úrovne 1-3 · Crypto Bear · Scam Bot · Regulator SEC",
    kombat_c2: "Úrovne 4-6 · Crypto Whale · FUD Spreader · Dark Miner",
    kombat_c3: "Úrovne 7-9 · Rug Puller · Moon Chaser · The Satoshi",
    kombat_rew_t: "Odmeny za víťazstvo",
    kombat_rew_v: "Úroveň 1: 500 R₿L → Úroveň 9: 50 000 R₿L",
    kombat_dist_t: "Distribúcia",
    kombat_d1: "95 % → Peňaženka víťaza",
    kombat_d2: "5 % → Burn adresa (trvalé spálenie)",
    kombat_limits_t: "Denné limity",
    kombat_l1: "Max 10 000 R₿L na peňaženku / deň",
    kombat_l2: "Max 3 zápasy s odmenou / deň",
    kombat_l3: "Iba PRO s pripojenou peňaženkou",

    // 18 Burn Mechanisms
    burn5_eyebrow: "// 18 BURNING MECHANIZMY",
    burn5_title: "5 zdrojov trvalého spaľovania",
    burn5_intro: "Token $R₿L má päť mechanizmov, ktoré nepretržite znižujú obeh tokenov. Všetky tokeny poslané na burn adresu sú nevratné.",
    burn5_addr: "Burn adresa: 0x000000000000000000000000000000000000dEaD",
    burn5_s1_t: "1 · PRO platba s R₿L",
    burn5_s1_d: "5 % spálené · 75 % Treasury · 20 % Vault pool",
    burn5_s2_t: "2 · Nákupy Shadow Market",
    burn5_s2_d: "5 % spálené · 95 % Treasury",
    burn5_s3_t: "3 · Learn-to-Earn odmeny",
    burn5_s3_d: "5 % spálené · 95 % študentovi",
    burn5_s4_t: "4 · RE₿EL Kombat odmeny",
    burn5_s4_d: "5 % spálené · 95 % víťazovi",
    burn5_s5_t: "5 · Hall of Flame · dobrovoľný burn",
    burn5_s5_d: "100 % spálené · verejný leaderboard",


    s12_eyebrow: "// 12 TÍM",
    s12_title: "Tvorcovia",
    s12_founder: "Zakladateľ",
    s12_ceo: "CEO",
    s12_d1: "Zakladateľ ekosystému RE₿EL.",
    s12_d2: "Výkonný riaditeľ.",

    s13_eyebrow: "// 13 METRIKY TOKENU",
    s13_title: "V číslach",
    s13_network: "Sieť",
    s13_supply: "Supply",
    s13_products: "Produkty",
    s13_core: "Hlavné platformy",

    s14_eyebrow: "// 14 OFICIÁLNE ODKAZY",
    s14_title: "Kde nás nájdeš",

    s15_eyebrow: "// 15 PRÁVNE",
    s15_title: "Disclaimery",
    s15_risk_t: "Rizikový disclaimer",
    s15_risk_b:
      "Kryptomenové trhy sú vysoko volatilné a špekulatívne. Cena R₿L — rovnako ako akéhokoľvek digitálneho aktíva — môže výrazne a rýchlo kolísať. Nikdy neinvestuj viac, ako si môžeš dovoliť stratiť. Nič v tomto dokumente nepredstavuje finančné, investičné, právne ani daňové poradenstvo. Vždy si rob vlastný prieskum (DYOR) a pred akýmkoľvek rozhodnutím sa poraď s kvalifikovaným odborníkom.",
    s15_privacy_t: "Zásady ochrany súkromia",
    s15_privacy_b:
      "RE₿EL zhromažďuje iba údaje nevyhnutne potrebné na prevádzku svojich služieb (účet, e-mail, on-chain interakcie, anonymná analytika). Osobné údaje nepredávame tretím stranám. Používatelia môžu kedykoľvek požiadať o prístup, opravu alebo vymazanie svojich údajov. Úplné detaily na rebelbtc.com/privacy.",
    s15_tos_t: "Podmienky služby",
    s15_tos_b:
      "Prístupom do ekosystému RE₿EL (Academy, TrendIA, Shadow Network, TopWallet, Shadow Market) súhlasíš s Podmienkami služby platformy. Služby sú poskytované 'tak ako sú', bez akýchkoľvek záruk. RE₿EL nenesie zodpovednosť za obchodné straty, obsah tretích strán ani prerušenia služby. Úplné podmienky na rebelbtc.com/terms.",
    s15_token_t: "Disclaimer tokenu",
    s15_token_b:
      "R₿L je úžitkový token používaný v rámci ekosystému RE₿EL na prístup, odmeny, governance a obchod. R₿L NIE JE cenný papier, NIE JE investičná zmluva a NEPREDSTAVUJE podiel, akciu, dividendu ani nárok na spoločnosť. Držanie R₿L neudeľuje držiteľovi žiadne ekonomické práva mimo zverejnenej úžitkovej hodnoty ekosystému. Regulačné zaobchádzanie s digitálnymi aktívami sa môže vyvíjať; používatelia sú zodpovední za súlad vo svojej jurisdikcii.",
    s15_legal_note:
      "R₿L je úžitkový token v rámci ekosystému RE₿EL. Nie je to cenný papier ani nie je určený ako investičný nástroj. Kryptomeny so sebou nesú riziko. Minulá výkonnosť nezaručuje budúce výsledky. Vždy si rob vlastný prieskum.",

    foot_motto: "Sloboda · Inteligencia · Decentralizácia",
  
    s10_c10: "Natívny swap",
    s10_c10_s: "Uniswap V3 Base · na rebelbtc.com",
    s10_c1_s: "50% zľava pri platbe R₿L · $19.95 vs $39.90",
    s10_c8_s: "Automaticky podľa úrovne diplomu",
    s10_c9: "Mechanický burning",
    s10_c9_s: "5% vypálené pri každej PRO platbe, nákupoch Shadow Market a odmenách Learn-to-Earn / RE₿EL Kombat",
  },

  "zh-CN": {
    wp_back: "← RE₿EL",
    wp_subtitle: "RE₿EL生态系统的经济引擎",
    wp_desc: "通过统一的代币经济，推动教育、人工智能、社交交易和数字商务。",
    wp_buy: "购买R₿L",
    wp_join: "加入社区",
    wp_pdf: "下载PDF",
    s1_eyebrow: "// 01 执行摘要",
    s1_title: "统一的代币经济",
    s1_para: "RE₿EL正在构建一个完整的生态系统，结合教育、人工智能、社交交易和数字商务——全部由R₿L代币驱动。",
    s1_b1: "教育",
    s1_b2: "人工智能",
    s1_b3: "社交交易",
    s1_b4: "数字商务",
    s1_p1: "Academy",
    s1_p2: "TrendIA",
    s1_p3: "Shadow Net",
    s1_p4: "TopWallet",
    s1_p5: "Market",
    s1_p6: "R₿L",
    s2_eyebrow: "// 02 市场机遇",
    s2_title: "万亿级市场全景",
    s2_m1: "AI",
    s2_m2: "加密货币",
    s2_m3: "数字教育",
    s2_m4: "创作者经济",
    s2_sources: "数据来源：2024-2026年行业预测（Statista、Messari、McKinsey、Block Research）。",
    s3_eyebrow: "// 03 生态系统地图",
    s3_title: "一个代币，六大支柱",
    s3_status_t: "生态系统当前状态",
    s3_st1: "Shadow Network — 个人资料、关注、AES-256加密消息、徽章、动态、发现和周排行榜 · 已上线",
    s3_st2: "Market Simulator™ — 无风险交易练习 · 已上线",
    s3_st3: "TrendIA — 在Google Play封闭测试中",
    s3_st4: "RE₿EL Proof™ — 6个级别的ERC-1155文凭已在Base L2上线",
    s3_st5: "Shadow Market — 商店已上线",
    s3_st6: "推荐计划 — 已上线",
    s3_n1: "RE₿EL Academy",
    s3_n2: "TrendIA",
    s3_n3: "Shadow Network",
    s3_n4: "TopWallet",
    s3_n5: "Shadow Market",
    s3_n6: "R₿L代币",
    s3_n7: "Base L2",
    s4_eyebrow: "// 04 RE₿EL ACADEMY",
    s4_title: "有回报的教育",
    s4_c1_t: "成人教育",
    s4_c1_s: "交易、宏观、DeFi精通",
    s4_c2_t: "儿童教育",
    s4_c2_s: "从第一天开始培养金融素养",
    s4_c3_t: "NFT证书",
    s4_c3_s: "RE₿EL Proof™ · Base L2上的ERC-1155",
    s4_c4_t: "交易课程",
    s4_c4_s: "现货、期货、期权",
    s4_c5_t: "游戏化",
    s4_c5_s: "经验值、等级、周任务",
    s4_c6_t: "已验证成就",
    s4_c6_s: "真实认证",
    s4_c7_t: "Market Simulator™",
    s4_c7_s: "无风险交易练习配排行榜",
    s5_eyebrow: "// 05 TRENDIA",
    s5_title: "AI解码市场",
    s5_c1: "AI Brain",
    s5_c2: "流动性地图",
    s5_c3: "Smart Money",
    s5_c4: "新闻扫描",
    s5_c5: "市场分析",
    s5_c6: "警报",
    s6_eyebrow: "// 06 SHADOW NETWORK",
    s6_title: "将交易知识变现",
    s6_c1_t: "订阅",
    s6_c1_s: "€或R₿L定期付款",
    s6_c2_t: "高级信号",
    s6_c2_s: "付费封闭交易设置",
    s6_c3_t: "联合分析",
    s6_c3_s: "50/50收益分成",
    s6_c4_t: "排名",
    s6_c4_s: "周排行榜带奖励",
    s6_c5_t: "奖励",
    s6_c5_s: "通过活动和准确预测赚取R₿L",
    s6_c6_t: "加密消息",
    s6_c6_s: "私密 · AES-256加密",
    s6_flow: "// 创作者收入流",
    s6_pays: "粉丝支付€或R₿L",
    s6_prizes: "周排行榜 — 前3名：$300 / $200 / $100 USDC · 第4-5名：Shadow Market 50% / 25%折扣。",
    s6_analyst: "分析师90%",
    s6_platform: "平台10%",
    s7_eyebrow: "// 07 TOPWALLET",
    s7_title: "始终选择正确的钱包",
    s7_c1_t: "+140个钱包",
    s7_c1_s: "精选热/冷/硬件钱包目录",
    s7_c2_t: "AI Wallet Advisor",
    s7_c2_s: "个性化推荐",
    s7_c3_t: "钱包评级",
    s7_c3_s: "专家和社区评分",
    s7_c4_t: "安全评分",
    s7_c4_s: "审计和开源状态",
    s7_th1: "钱包",
    s7_th2: "类型",
    s7_th3: "安全性",
    s7_th4: "评级",
    s7_t1: "Hardware",
    s7_t2: "浏览器",
    s7_t3: "移动端",
    s7_affiliates: "活跃的官方联盟计划：Ledger和Trezor。",
    s8_eyebrow: "// 08 SHADOW MARKET",
    s8_title: "AI设计的高级商品",
    s8_c1: "定制服装",
    s8_c2: "AI设计",
    s8_c3: "数字产品",
    s8_c4: "高级商品",
    s9_eyebrow: "// 09 代币经济",
    s9_title: "1,000,000,000 R₿L",
    s9_supply: "R₿L供应量",
    s9_d1: "生态系统",
    s9_d2: "流动性",
    s9_d3: "奖励",
    s9_d4: "开发",
    s9_d5: "营销",
    liq_lock_title: "流动性已锁定",
    liq_lock_detail: "PancakeSwap Base · 1,168 Cake-LP · 12个月",
    liq_lock_until: "锁定至2027年6月9日",
    liq_lock_verify: "链上验证",
    liq_lock_cta: "在PinkLock查看证明",
    sec_lock_trust: "✅ 流动性在PinkLock锁定12个月 — 可公开验证",
    tok_facts_title: "可在链上验证的数据",
    tok_contract_t: "R₿L代币 · ERC-20",
    tok_proof_t: "RE₿EL Proof™ · ERC-1155",
    tok_supply_note: "固定供应量1,000,000,000 R₿L — 合约不包含铸造或销毁功能。",
    s9_split_t: "每笔R₿L PRO付款的分配",
    s9_split_1: "Treasury — 学院运营",
    s9_split_2: "Vault pool — 持有者收益",
    s9_split_3: "Burn address — 永久销毁",
    tok_listings_t: "上线和交易所",
    tok_li1: "Uniswap V3 (Base) — 已上线",
    tok_li2: "PancakeSwap V2 (Base) — 已上线 · LP锁定至2027年6月9日",
    tok_li3: "CoinGecko — 已提交申请",
    tok_li4: "CoinMarketCap — 已提交申请 · 工单 #1372525",
    tok_pools_t: "活跃池",
    tok_pools_v: "Uniswap V3 (Base) · PancakeSwap (Base)",
    s10_eyebrow: "// 10 代币实用性",
    s10_title: "R₿L解锁什么",
    s10_c1: "PRO访问权限",
    s10_c2: "治理",
    s10_c3: "Shadow Market 15%折扣",
    s10_c4: "奖励",
    s10_c5: "曝光度提升",
    s10_c6: "分析师订阅",
    s10_c7: "质押×1.5倍（30天）",
    s10_c8: "空投RE₿EL Proof™",
    s10_vault_t: "R₿L Vault",
    s10_vault_s: "持有者可以将R₿L存入Vault，每月获得学院20%链上PRO收入的一部分。收益由真实业务收入支持，而非投机。随时可提取（30天内提取收取5%费用 · 最低存入100,000 R₿L）。",
    s10_c1_s: "用R₿L支付享50%折扣 · $19.95 vs $39.90",
    s10_c8_s: "根据文凭级别自动发放",
    s10_c9: "机械销毁",
    s10_c9_s: "每笔PRO付款、Shadow Market购买和Learn-to-Earn / RE₿EL Kombat奖励销毁5%",
    s10_c10: "原生Swap",
    s10_c10_s: "Uniswap V3 Base · 在rebelbtc.com",
    s11_eyebrow: "// 11 路线图",
    s11_title: "七个阶段",
    s11_done: "已完成",
    s11_progress: "进行中",
    s11_soon: "即将推出",
    s11_f1_t: "代币和账本",
    s11_f1: [
      "Base L2上的ERC-20",
      "R₿L内部账本",
      "活动奖励"
    ],
    s11_f2_t: "Shadow Network",
    s11_f2: [
      "社交动态和信号",
      "AI导师 · 日志",
      "订阅和支付"
    ],
    s11_f3_t: "链上和Web3",
    s11_f3: [
      "1:1链上转换",
      "Wallet Connect (Base)",
      "双账本"
    ],
    s11_f4_t: "流动性和上线",
    s11_f4: [
      "Uniswap · PancakeSwap池",
      "LP锁定12个月",
      "DexScreener · GeckoTerminal"
    ],
    s11_f5_t: "完整生态系统",
    s11_f5: [
      "R₿L治理",
      "空投RE₿EL Proof™",
      "R₿L PRO访问和课程",
      "Copy Simulator",
      "TrendIA集成"
    ],
    s11_f6_t: "高级代币经济",
    s11_f6: [
      "R₿L Vault — 20% PRO收入",
      "多源销毁5%",
      "学院Learn-to-Earn",
      "Uniswap V3原生Swap",
      "实时代币经济仪表板",
      "CoinGecko · CMC审核中"
    ],
    s11_f7_t: "生态系统扩展",
    s11_f7: [
      "RE₿EL移动钱包",
      "RE₿EL Kombat边玩边赚",
      "R₿L交易锦标赛",
      "RE₿EL Mentors · 直播课程",
      "NFT徽章 · RE₿EL DAO",
      "CEX上线"
    ],
    l2e_eyebrow: "// 16 LEARN-TO-EARN",
    l2e_title: "学习并赚取$R₿L",
    l2e_intro: "RE₿EL Academy通过完成章节奖励PRO用户真实的$R₿L代币。系统具有6层防作弊验证，确保真实学习。",
    l2e_rewards_t: "每章奖励",
    l2e_r1: "基础：500 – 2,000 R₿L",
    l2e_r2: "中级：1,500 – 5,000 R₿L",
    l2e_r3: "高级：3,000 – 10,000 R₿L",
    l2e_r4: "完整模块奖励：+25,000 R₿L",
    l2e_r5: "课程+文凭奖励：+100,000 R₿L",
    l2e_dist_t: "每次奖励的分配",
    l2e_dist_1: "95% → 学生钱包（真实R₿L · Base L2）",
    l2e_dist_2: "5% → Burn address（永久销毁）",
    l2e_anti_t: "防作弊系统 · 6层",
    l2e_a1: "服务器端计时器 · 最短阅读时间",
    l2e_a2: "真实活动检测 · 每30秒ping",
    l2e_a3: "强制测验 · 5题至少答对4题",
    l2e_a4: "章节间冷却 · 15-60分钟",
    l2e_a5: "每日限额 · 最多20,000 R₿L/天",
    l2e_a6: "顺序进度 · 不能跳过章节",
    kombat_eyebrow: "// 17 RE₿EL KOMBAT",
    kombat_title: "边玩边赚游戏",
    kombat_intro: "Mortal Kombat风格的1v1格斗游戏，加密货币主题。The Rebel与9个加密世界反派战斗，难度逐级递增。",
    kombat_chars_t: "角色",
    kombat_c1: "第1-3关 · Crypto Bear · Scam Bot · Regulator SEC",
    kombat_c2: "第4-6关 · Crypto Whale · FUD Spreader · Dark Miner",
    kombat_c3: "第7-9关 · Rug Puller · Moon Chaser · The Satoshi",
    kombat_rew_t: "胜利奖励",
    kombat_rew_v: "第1关：500 R₿L → 第9关：50,000 R₿L",
    kombat_dist_t: "分配",
    kombat_d1: "95% → 获胜玩家钱包",
    kombat_d2: "5% → Burn address（永久销毁）",
    kombat_limits_t: "每日限额",
    kombat_l1: "每个钱包每天最多10,000 R₿L",
    kombat_l2: "每天最多3场有奖励的游戏",
    kombat_l3: "仅限已连接钱包的PRO用户",
    burn5_eyebrow: "// 18 销毁机制",
    burn5_title: "5个永久销毁来源",
    burn5_intro: "$R₿L代币具有五个机制，持续减少流通供应量。所有发送到销毁地址的代币不可恢复。",
    burn5_addr: "销毁地址：0x000000000000000000000000000000000000dEaD",
    burn5_s1_t: "1 · 用R₿L支付PRO",
    burn5_s1_d: "5%销毁 · 75% Treasury · 20% Vault pool",
    burn5_s2_t: "2 · Shadow Market购买",
    burn5_s2_d: "5%销毁 · 95% Treasury",
    burn5_s3_t: "3 · Learn-to-Earn奖励",
    burn5_s3_d: "5%销毁 · 95%给学生",
    burn5_s4_t: "4 · RE₿EL Kombat奖励",
    burn5_s4_d: "5%销毁 · 95%给获胜者",
    burn5_s5_t: "5 · Hall of Flame · 自愿销毁",
    burn5_s5_d: "100%销毁 · 公开排行榜",
    s12_eyebrow: "// 12 团队",
    s12_title: "建设者",
    s12_founder: "创始人",
    s12_ceo: "首席执行官",
    s12_d1: "RE₿EL生态系统创始人。",
    s12_d2: "首席执行官。",
    s13_eyebrow: "// 13 代币指标",
    s13_title: "数据一览",
    s13_network: "网络",
    s13_supply: "供应量",
    s13_products: "产品",
    s13_core: "核心平台",
    s14_eyebrow: "// 14 官方链接",
    s14_title: "在哪里找到我们",
    s15_eyebrow: "// 15 法律",
    s15_title: "免责声明",
    s15_risk_t: "风险免责声明",
    s15_risk_b: "加密货币市场高度波动且具有投机性。R₿L的价格——以及任何数字资产——都可能出现重大且快速的波动。切勿投资超过您可承受损失的金额。本文档中的任何内容均不构成财务、投资、法律或税务建议。在做出任何决策之前，务必进行自己的研究（DYOR）并咨询合格的专业人士。",
    s15_privacy_t: "隐私政策",
    s15_privacy_b: "RE₿EL仅收集运营其服务所必需的数据（账户、电子邮件、链上交互、匿名分析）。我们不向第三方出售个人数据。用户可随时请求访问、更正或删除其数据。完整详情请访问rebelbtc.com/privacy。",
    s15_tos_t: "服务条款",
    s15_tos_b: "访问RE₿EL生态系统（Academy、TrendIA、Shadow Network、TopWallet、Shadow Market）即表示您接受平台的服务条款。服务按\"现状\"提供，不作任何类型的保证。RE₿EL不对交易损失、第三方内容或服务中断负责。完整条款请访问rebelbtc.com/terms。",
    s15_token_t: "代币免责声明",
    s15_token_b: "R₿L是RE₿EL生态系统内用于访问、奖励、治理和交易的实用型代币。R₿L不是证券，不是投资合约，不代表股票、股权、股息或公司权利。持有R₿L不授予持有者生态系统公布的实用性之外的任何经济权利。数字资产的监管处理可能演变；每位用户负责遵守其所在司法管辖区的法规。",
    s15_legal_note: "R₿L是RE₿EL生态系统内的实用型代币。它不是证券，也不旨在作为投资工具。加密货币具有风险。过往表现不保证未来结果。务必进行自己的研究。",
    foot_motto: "自由 · 智能 · 去中心化",
  },

  de: {
    wp_back: "← RE₿EL",
    wp_subtitle: "Der wirtschaftliche Motor des RE₿EL-Ökosystems",
    wp_desc: "Antrieb für Bildung, künstliche Intelligenz, Social Trading und digitalen Handel durch eine einheitliche Token-Ökonomie.",
    wp_buy: "R₿L kaufen",
    wp_join: "Der Community beitreten",
    wp_pdf: "PDF herunterladen",
    s1_eyebrow: "// 01 ZUSAMMENFASSUNG",
    s1_title: "Eine einheitliche Token-Ökonomie",
    s1_para: "RE₿EL baut ein vollständiges Ökosystem auf, das Bildung, künstliche Intelligenz, Social Trading und digitalen Handel kombiniert — alles angetrieben durch den R₿L-Token.",
    s1_b1: "Bildung",
    s1_b2: "Künstliche Intelligenz",
    s1_b3: "Social Trading",
    s1_b4: "Digitaler Handel",
    s1_p1: "Academy",
    s1_p2: "TrendIA",
    s1_p3: "Shadow Net",
    s1_p4: "TopWallet",
    s1_p5: "Market",
    s1_p6: "R₿L",
    s2_eyebrow: "// 02 MARKTCHANCE",
    s2_title: "Eine Billionen-Landschaft",
    s2_m1: "KI",
    s2_m2: "Krypto",
    s2_m3: "Digitale Bildung",
    s2_m4: "Creator Economy",
    s2_sources: "Quellen: Branchenschätzungen 2024-2026 (Statista, Messari, McKinsey, Block Research).",
    s3_eyebrow: "// 03 ÖKOSYSTEM-MAP",
    s3_title: "Ein Token, sechs Säulen",
    s3_status_t: "Aktueller Ökosystem-Status",
    s3_st1: "Shadow Network — Profile, Follow, AES-256-Nachrichten, Badges, Feed, Discovery und wöchentliches Ranking · aktiv",
    s3_st2: "Market Simulator™ — risikofreies Trading-Training · aktiv",
    s3_st3: "TrendIA — im Closed Testing auf Google Play",
    s3_st4: "RE₿EL Proof™ — 6 ERC-1155-Diplom-Level aktiv auf Base L2",
    s3_st5: "Shadow Market — Shop aktiv",
    s3_st6: "Empfehlungsprogramm — aktiv",
    s3_n1: "RE₿EL Academy",
    s3_n2: "TrendIA",
    s3_n3: "Shadow Network",
    s3_n4: "TopWallet",
    s3_n5: "Shadow Market",
    s3_n6: "Token R₿L",
    s3_n7: "Base L2",
    s4_eyebrow: "// 04 RE₿EL ACADEMY",
    s4_title: "Bildung, die belohnt",
    s4_c1_t: "Erwachsenenbildung",
    s4_c1_s: "Trading, Makro, DeFi-Beherrschung",
    s4_c2_t: "Kinderbildung",
    s4_c2_s: "Finanzkultur vom ersten Tag an",
    s4_c3_t: "NFT-Zertifikate",
    s4_c3_s: "RE₿EL Proof™ · ERC-1155 auf Base L2",
    s4_c4_t: "Trading-Kurse",
    s4_c4_s: "Spot, Futures, Optionen",
    s4_c5_t: "Gamification",
    s4_c5_s: "XP, Level, wöchentliche Missionen",
    s4_c6_t: "Verifizierte Erfolge",
    s4_c6_s: "Echte Zertifizierungen",
    s4_c7_t: "Market Simulator™",
    s4_c7_s: "Risikofreies Trading-Training mit Leaderboard",
    s5_eyebrow: "// 05 TRENDIA",
    s5_title: "Märkte, entschlüsselt durch KI",
    s5_c1: "AI Brain",
    s5_c2: "Liquiditätskarte",
    s5_c3: "Smart Money",
    s5_c4: "News-Scanner",
    s5_c5: "Marktanalyse",
    s5_c6: "Benachrichtigungen",
    s6_eyebrow: "// 06 SHADOW NETWORK",
    s6_title: "Monetarisiere dein Trading-Wissen",
    s6_c1_t: "Abonnements",
    s6_c1_s: "€ oder R₿L wiederkehrend",
    s6_c2_t: "Premium-Signale",
    s6_c2_s: "Geschlossene Paid-Setups",
    s6_c3_t: "Co-Analyse",
    s6_c3_s: "50/50-Aufteilung",
    s6_c4_t: "Rankings",
    s6_c4_s: "Wöchentliches Ranking mit Preisen",
    s6_c5_t: "Belohnungen",
    s6_c5_s: "Verdiene R₿L durch Aktivität und Treffer",
    s6_c6_t: "Verschlüsselte Nachrichten",
    s6_c6_s: "Privat · AES-256-Verschlüsselung",
    s6_flow: "// CREATOR-EINKOMMENSFLUSS",
    s6_pays: "Der Follower zahlt € oder R₿L",
    s6_prizes: "Wöchentliches Ranking — Top 3: $300 / $200 / $100 USDC · Plätze 4-5: 50% / 25% Rabatt auf Shadow Market.",
    s6_analyst: "Analyst 90%",
    s6_platform: "Plattform 10%",
    s7_eyebrow: "// 07 TOPWALLET",
    s7_title: "Wähle immer die richtige Wallet",
    s7_c1_t: "+140 Wallets",
    s7_c1_s: "Kuratierter Katalog hot/cold/HW",
    s7_c2_t: "AI Wallet Advisor",
    s7_c2_s: "Personalisierte Empfehlung",
    s7_c3_t: "Wallet-Bewertung",
    s7_c3_s: "Experten- und Community-Score",
    s7_c4_t: "Sicherheitsbewertungen",
    s7_c4_s: "Audit und Open-Source-Status",
    s7_th1: "Wallet",
    s7_th2: "Typ",
    s7_th3: "Sicherheit",
    s7_th4: "Bewertung",
    s7_t1: "Hardware",
    s7_t2: "Browser",
    s7_t3: "Mobil",
    s7_affiliates: "Offizielle aktive Affiliate-Programme: Ledger und Trezor.",
    s8_eyebrow: "// 08 SHADOW MARKET",
    s8_title: "Premium-Merch, KI-gestaltet",
    s8_c1: "Personalisierte Kleidung",
    s8_c2: "KI-Design",
    s8_c3: "Digitale Produkte",
    s8_c4: "Premium-Merch",
    s9_eyebrow: "// 09 TOKENOMICS",
    s9_title: "1.000.000.000 R₿L",
    s9_supply: "R₿L SUPPLY",
    s9_d1: "Ökosystem",
    s9_d2: "Liquidität",
    s9_d3: "Belohnungen",
    s9_d4: "Entwicklung",
    s9_d5: "Marketing",
    liq_lock_title: "Liquidität gesperrt",
    liq_lock_detail: "PancakeSwap Base · 1.168 Cake-LP · 12 Monate",
    liq_lock_until: "Gesperrt bis 9. Juni 2027",
    liq_lock_verify: "On-Chain-Verifizierung",
    liq_lock_cta: "Nachweis auf PinkLock ansehen",
    sec_lock_trust: "✅ Liquidität für 12 Monate auf PinkLock gesperrt — öffentlich verifizierbar",
    tok_facts_title: "On-Chain verifizierbare Fakten",
    tok_contract_t: "Token R₿L · ERC-20",
    tok_proof_t: "RE₿EL Proof™ · ERC-1155",
    tok_supply_note: "Festes Supply von 1.000.000.000 R₿L — der Vertrag enthält keine Minting- oder Burning-Funktionen.",
    s9_split_t: "Verteilung jeder PRO-Zahlung in R₿L",
    s9_split_1: "Treasury — Academy-Operationen",
    s9_split_2: "Vault Pool — Yield für Holder",
    s9_split_3: "Burn Address — permanent verbrannt",
    tok_listings_t: "Listings und Börsen",
    tok_li1: "Uniswap V3 (Base) — aktiv",
    tok_li2: "PancakeSwap V2 (Base) — aktiv · LP gesperrt bis 09-06-2027",
    tok_li3: "CoinGecko — Antrag eingereicht",
    tok_li4: "CoinMarketCap — Antrag eingereicht · Ticket #1372525",
    tok_pools_t: "Aktive Pools",
    tok_pools_v: "Uniswap V3 (Base) · PancakeSwap (Base)",
    s10_eyebrow: "// 10 TOKEN-UTILITY",
    s10_title: "Was R₿L freischaltet",
    s10_c1: "PRO-Zugang",
    s10_c2: "Governance",
    s10_c3: "15% Rabatt Shadow Market",
    s10_c4: "Belohnungen",
    s10_c5: "Sichtbarkeits-Boost",
    s10_c6: "Analisten-Abonnements",
    s10_c7: "Staking ×1.5 (30 Tage)",
    s10_c8: "Airdrop RE₿EL Proof™",
    s10_vault_t: "R₿L Vault",
    s10_vault_s: "Holder können R₿L im Vault hinterlegen und monatlich einen Anteil der 20% PRO-On-Chain-Einnahmen der Academy erhalten. Yield basiert auf echten Geschäftseinnahmen, nicht auf Spekulation. Auszahlung jederzeit möglich (5% Gebühr vor 30 Tagen · Mindesteinlage 100.000 R₿L).",
    s10_c1_s: "50% Rabatt bei Zahlung mit R₿L · $19.95 vs $39.90",
    s10_c8_s: "Automatisch nach Diplom-Level",
    s10_c9: "Mechanisches Burning",
    s10_c9_s: "5% verbrannt bei jeder PRO-Zahlung, Shadow Market-Käufen und Learn-to-Earn / RE₿EL Kombat Belohnungen",
    s10_c10: "Nativer Swap",
    s10_c10_s: "Uniswap V3 Base · auf rebelbtc.com",
    s11_eyebrow: "// 11 ROADMAP",
    s11_title: "Sieben Phasen",
    s11_done: "Abgeschlossen",
    s11_progress: "In Bearbeitung",
    s11_soon: "Demnächst",
    s11_f1_t: "Token & Ledger",
    s11_f1: [
      "ERC-20 auf Base L2",
      "Internes R₿L-Ledger",
      "Aktivitätsbelohnungen"
    ],
    s11_f2_t: "Shadow Network",
    s11_f2: [
      "Social Feed und Signale",
      "Mentor KI · Journal",
      "Abonnements und Zahlungen"
    ],
    s11_f3_t: "On-Chain & Web3",
    s11_f3: [
      "1:1-Konvertierung on-chain",
      "Wallet Connect (Base)",
      "Dual Ledger"
    ],
    s11_f4_t: "Liquidität & Listings",
    s11_f4: [
      "Uniswap · PancakeSwap Pools",
      "LP für 12 Monate gesperrt",
      "DexScreener · GeckoTerminal"
    ],
    s11_f5_t: "Vollständiges Ökosystem",
    s11_f5: [
      "Governance mit R₿L",
      "Airdrop RE₿EL Proof™",
      "R₿L PRO-Zugang und Kurse",
      "Copy Simulator",
      "TrendIA Integration"
    ],
    s11_f6_t: "Erweiterte Token Economy",
    s11_f6: [
      "R₿L Vault — 20% PRO-Einnahmen",
      "Multi-Source Burning 5%",
      "Learn-to-Earn Academy",
      "Nativer Uniswap V3 Swap",
      "Live Tokenomics Dashboard",
      "CoinGecko · CMC in Prüfung"
    ],
    s11_f7_t: "Ökosystem-Expansion",
    s11_f7: [
      "RE₿EL Wallet mobil",
      "RE₿EL Kombat play-to-earn",
      "R₿L Trading-Turniere",
      "RE₿EL Mentors · Live-Kurse",
      "NFT Badges · RE₿EL DAO",
      "CEX-Listing"
    ],
    l2e_eyebrow: "// 16 LEARN-TO-EARN",
    l2e_title: "Lerne und verdiene $R₿L",
    l2e_intro: "RE₿EL Academy belohnt PRO-Nutzer mit echten $R₿L-Token für das Abschließen von Kapiteln. System mit 6-lagiger Anti-Betrugs-Verifizierung zur Sicherstellung echten Lernens.",
    l2e_rewards_t: "Belohnungen pro Kapitel",
    l2e_r1: "Grundlagen: 500 – 2.000 R₿L",
    l2e_r2: "Fortgeschritten: 1.500 – 5.000 R₿L",
    l2e_r3: "Experten: 3.000 – 10.000 R₿L",
    l2e_r4: "Modul-Abschluss-Bonus: +25.000 R₿L",
    l2e_r5: "Kurs + Diplom-Bonus: +100.000 R₿L",
    l2e_dist_t: "Verteilung jeder Belohnung",
    l2e_dist_1: "95% → Wallet des Schülers (echte R₿L · Base L2)",
    l2e_dist_2: "5% → Burn Address (permanent verbrannt)",
    l2e_anti_t: "Anti-Betrugs-System · 6 Ebenen",
    l2e_a1: "Server-seitiger Timer · minimale Lesezeit",
    l2e_a2: "Erkennung echter Aktivität · Pings alle 30s",
    l2e_a3: "Pflicht-Quiz · mindestens 4 von 5 richtig",
    l2e_a4: "Cooldown zwischen Kapiteln · 15-60 min",
    l2e_a5: "Tageslimit · maximal 20.000 R₿L / Tag",
    l2e_a6: "Geordnete Progression · Kapitel nicht überspringen",
    kombat_eyebrow: "// 17 RE₿EL KOMBAT",
    kombat_title: "Play-to-Earn-Spiel",
    kombat_intro: "1vs1-Kampfspiel im Mortal Kombat-Stil mit Krypto-Thematik. The Rebel kämpft gegen 9 Bösewichte aus der Krypto-Welt in steigenden Schwierigkeitsgraden.",
    kombat_chars_t: "Charaktere",
    kombat_c1: "Level 1-3 · Crypto Bear · Scam Bot · Regulator SEC",
    kombat_c2: "Level 4-6 · Crypto Whale · FUD Spreader · Dark Miner",
    kombat_c3: "Level 7-9 · Rug Puller · Moon Chaser · The Satoshi",
    kombat_rew_t: "Belohnungen pro Sieg",
    kombat_rew_v: "Level 1: 500 R₿L → Level 9: 50.000 R₿L",
    kombat_dist_t: "Verteilung",
    kombat_d1: "95% → Wallet des Gewinners",
    kombat_d2: "5% → Burn Address (permanent verbrannt)",
    kombat_limits_t: "Tageslimits",
    kombat_l1: "Maximal 10.000 R₿L pro Wallet / Tag",
    kombat_l2: "Maximal 3 Spiele mit Belohnung / Tag",
    kombat_l3: "Nur PRO mit verbundener Wallet",
    burn5_eyebrow: "// 18 BURNING-MECHANISMEN",
    burn5_title: "5 Quellen permanenter Verbrennung",
    burn5_intro: "Der $R₿L-Token verfügt über fünf Mechanismen, die das zirkulierende Supply kontinuierlich reduzieren. Alle zur Burn Address gesendeten Token sind unwiederbringlich.",
    burn5_addr: "Burn Address: 0x000000000000000000000000000000000000dEaD",
    burn5_s1_t: "1 · PRO-Zahlung mit R₿L",
    burn5_s1_d: "5% verbrannt · 75% Treasury · 20% Vault Pool",
    burn5_s2_t: "2 · Shadow Market Käufe",
    burn5_s2_d: "5% verbrannt · 95% Treasury",
    burn5_s3_t: "3 · Learn-to-Earn Belohnungen",
    burn5_s3_d: "5% verbrannt · 95% an Schüler",
    burn5_s4_t: "4 · RE₿EL Kombat Belohnungen",
    burn5_s4_d: "5% verbrannt · 95% an Gewinner",
    burn5_s5_t: "5 · Hall of Flame · freiwilliges Burning",
    burn5_s5_d: "100% verbrannt · öffentliches Leaderboard",
    s12_eyebrow: "// 12 TEAM",
    s12_title: "Builder",
    s12_founder: "Founder",
    s12_ceo: "CEO",
    s12_d1: "Gründer des RE₿EL-Ökosystems.",
    s12_d2: "Geschäftsführer.",
    s13_eyebrow: "// 13 TOKEN-METRIKEN",
    s13_title: "In Zahlen",
    s13_network: "Netzwerk",
    s13_supply: "Supply",
    s13_products: "Produkte",
    s13_core: "Hauptplattformen",
    s14_eyebrow: "// 14 OFFIZIELLE LINKS",
    s14_title: "Wo Sie uns finden",
    s15_eyebrow: "// 15 RECHTLICHES",
    s15_title: "Haftungsausschlüsse",
    s15_risk_t: "Risiko-Haftungsausschluss",
    s15_risk_b: "Kryptowährungsmärkte sind hochvolatil und spekulativ. Der Preis von R₿L — und jedes digitalen Vermögenswerts — kann erheblich und schnell schwanken. Investieren Sie niemals mehr, als Sie sich leisten können zu verlieren. Nichts in diesem Dokument stellt Finanz-, Anlage-, Rechts- oder Steuerberatung dar. Führen Sie immer Ihre eigene Recherche durch (DYOR) und konsultieren Sie einen qualifizierten Fachmann, bevor Sie Entscheidungen treffen.",
    s15_privacy_t: "Datenschutzrichtlinie",
    s15_privacy_b: "RE₿EL erfasst nur die Daten, die für den Betrieb seiner Dienste unbedingt erforderlich sind (Konto, E-Mail, On-Chain-Interaktionen, anonyme Analytik). Wir verkaufen keine personenbezogenen Daten an Dritte. Nutzer können jederzeit Zugang, Korrektur oder Löschung ihrer Daten beantragen. Vollständige Details unter rebelbtc.com/privacy.",
    s15_tos_t: "Nutzungsbedingungen",
    s15_tos_b: "Durch den Zugriff auf das RE₿EL-Ökosystem (Academy, TrendIA, Shadow Network, TopWallet, Shadow Market) akzeptieren Sie die Nutzungsbedingungen der Plattform. Die Dienste werden \"wie besehen\" ohne jegliche Garantien angeboten. RE₿EL haftet nicht für Trading-Verluste, Inhalte Dritter oder Dienstunterbrechungen. Vollständige Bedingungen unter rebelbtc.com/terms.",
    s15_token_t: "Token-Haftungsausschluss",
    s15_token_b: "R₿L ist ein Utility-Token, der innerhalb des RE₿EL-Ökosystems für Zugang, Belohnungen, Governance und Handel verwendet wird. R₿L ist KEIN Wertpapier, KEIN Investitionsvertrag und stellt KEINE Aktie, Eigenkapital, Dividende oder Rechte am Unternehmen dar. Der Besitz von R₿L gewährt dem Inhaber keine wirtschaftlichen Rechte außerhalb der veröffentlichten Ökosystem-Utility. Die regulatorische Behandlung digitaler Vermögenswerte kann sich weiterentwickeln; jeder Nutzer ist für die Einhaltung der Vorschriften in seiner Gerichtsbarkeit verantwortlich.",
    s15_legal_note: "R₿L ist ein Utility-Token innerhalb des RE₿EL-Ökosystems. Es ist kein Wertpapier und nicht als Anlageinstrument gedacht. Kryptowährungen bergen Risiken. Die vergangene Performance garantiert keine zukünftigen Ergebnisse. Führen Sie immer Ihre eigene Recherche durch.",
    foot_motto: "Freiheit · Intelligenz · Dezentralisierung",
  },
};

export const tWP = (lang, key) => {
  const dict = WHITEPAPER_I18N[lang] || WHITEPAPER_I18N.es;
  if (dict[key] !== undefined) return dict[key];
  return WHITEPAPER_I18N.es[key] !== undefined ? WHITEPAPER_I18N.es[key] : key;
};

export default WHITEPAPER_I18N;
;
